import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Dashboard, ECommerceDashboard } from "../../../../Constants/Constants";
import AddProductCard from "./AddProductCard";
import CurrentActivity from "./CurrentActivity";
import FriendCard from "./FriendCard";
import GoalSummary from "./GoalSummary";
import OnlineSalesCard from "./OnlineSalesCard";
import OrdersByCountries from "./OrdersByCountries";
import SaleStatistic from "./SaleStatistic";
import SpecialDiscountCard from "./SpecialDiscountCard";
import SupportMailbox from "./SupportMailbox";
import TopSellingProducts from "./TopSellingProducts/TopSellingProducts";
import { Fragment } from "react/jsx-runtime";

const EcommerceContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ECommerceDashboard} parent={Dashboard} />
      <Container fluid className="ecommerce-dashboard">
        <Row>
          <OnlineSalesCard />
          <OrdersByCountries />
          <TopSellingProducts />
          <SaleStatistic />
          <GoalSummary />
          <CurrentActivity />
          <SupportMailbox />
          <AddProductCard />
          <SpecialDiscountCard />
          <FriendCard />
        </Row>
      </Container>
    </Fragment>
  );
};

export default EcommerceContainer;
